import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";
import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBorderBtn from "../../components/atoms/button/mainBorderBtn";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdDisplay01 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay01";
import LSRgCaption03 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption03";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSBdBody02 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody02";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSBdCaption02 from "../../components/molecules/text/linSeedKr/Bd/lsBdCaption02";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSRgCaption01 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import PaymentApi from "../../api/payment.api";
import { errorHandler } from "../../util/errorHandler";
import { fileUrl } from "../../api/api";
import moment from "moment";
import {
  formatNumberWithCommas,
  formatPhoneNumber,
} from "../../util/formatNumber";
import { toast } from "react-toastify";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import Loading from "../../components/templates/loading";

const MyPagePaymentDetail = () => {
  const { id } = useParams();

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();
  const [paymentInfo, setPaymentInfo] = useState({});
  const [isRefundModal, setIsRefundModal] = useState(false);
  const [isRefunding, setIsRefunding] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          `${route.my_page_payment_detail}/${id}`,
        )}`,
        { replace: true },
      );
      return;
    }

    if (!/^\d+$/.test(id) || Number(id) < 1) {
      toast("올바르지 않은 결제 내역입니다.");
      navigate(route.my_page_payment_history, { replace: true });
      return;
    }

    getPaymentInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getPaymentInfo = async () => {
    try {
      const response = (await PaymentApi.getDetail(id)).data.data.content;

      setPaymentInfo(response);
    } catch (error) {
      errorHandler(error);
      navigate(route.my_page_payment_history, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  const refundFunc = async () => {
    if (isRefunding) return;

    try {
      setIsRefunding(true);
      await PaymentApi.refund(id);
      toast("취소 및 환불 신청되었습니다.");
      navigate(route.my_page_payment_refund, { replace: true });
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsRefunding(false);
    }
  };

  const canRequestRefund =
    paymentInfo?.paymentFlag === true &&
    paymentInfo?.paymentStatus === "COMPLETE";

  if (isLoading) return <Loading />;

  return (
    <LecturePaymentCompleteSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            padding: "80px 0px 150px 0px",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 60,
            }}
          >
            <LSBdDisplay02>결제 내역 상세</LSBdDisplay02>
          </div>

          <LSBdH2HeadLine
            style={{
              color: "#5050FF",
            }}
          >
            구매 정보
          </LSBdH2HeadLine>

          <Divider
            style={{
              marginTop: 16,
              marginBottom: 30,
            }}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={
                paymentInfo?.thumbnailServerFileName
                  ? `${fileUrl}/${paymentInfo?.thumbnailServerFileName}`
                  : ""
              }
              style={{
                width: 175,
                height: 112,
                marginRight: 40,
                borderRadius: 8,
              }}
              alt="video"
            />
            <LSBdDisplay01
              style={{
                flex: 1,
                color: "#000000",
                marginRight: 90,
              }}
            >
              {paymentInfo?.lectureTitle}
            </LSBdDisplay01>

            <div
              style={{
                minWidth: 260,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TopTextContain>
                <TopRightText>결제번호</TopRightText>
                <TopLeftText>{paymentInfo?.pgPaymentId}</TopLeftText>
              </TopTextContain>
              <TopTextContain>
                <TopRightText>결제일자</TopRightText>
                <TopLeftText>
                  {moment(paymentInfo?.createdAt).format("YYYY.MM.DD HH:mm:ss")}
                </TopLeftText>
              </TopTextContain>
              <TopTextContain>
                <TopRightText>결제금액</TopRightText>
                <TopLeftText>
                  {formatNumberWithCommas(paymentInfo?.realPay)}원
                </TopLeftText>
              </TopTextContain>
              <TopTextContain>
                <TopRightText>결제수단</TopRightText>
                <TopLeftText>{paymentInfo?.payMethod}</TopLeftText>
              </TopTextContain>
              <TopTextContain>
                <TopRightText>결제상태</TopRightText>
                <TopLeftText>
                  {paymentInfo?.paymentStatus === "REFUND_COMPLETE"
                    ? "환불완료"
                    : paymentInfo?.paymentStatus === "REFUND_REQUEST"
                      ? "환불신청"
                      : "결제완료"}
                </TopLeftText>
              </TopTextContain>
            </div>
          </div>

          <LSBdH2HeadLine
            style={{
              color: "#5050FF",
              marginTop: 60,
            }}
          >
            구매자 정보
          </LSBdH2HeadLine>

          <Divider
            style={{
              marginTop: 16,
              marginBottom: 30,
            }}
          />

          <TopTextContain>
            <TopRightText>구매자</TopRightText>
            <TopLeftText>{paymentInfo?.name}</TopLeftText>
          </TopTextContain>
          <TopTextContain>
            <TopRightText>전화번호</TopRightText>
            <TopLeftText>
              {formatPhoneNumber(paymentInfo?.phoneNumber)}
            </TopLeftText>
          </TopTextContain>
          <TopTextContain>
            <TopRightText>이메일</TopRightText>
            <TopLeftText>{paymentInfo?.email}</TopLeftText>
          </TopTextContain>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 100,
            }}
          >
            <MainBtn
              onClick={() => {
                navigate(route.my_page_classroom);
              }}
              style={{
                marginRight: 30,
                width: 380,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                나의 강의실 가기
              </LSRgH1HeadLine>
            </MainBtn>

            {canRequestRefund && (
              <MainBorderBtn
                disabled={isRefunding}
                onClick={() => {
                  setIsRefundModal(true);
                }}
                style={{
                  width: 380,
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#5050FF",
                    textAlign: "center",
                  }}
                >
                  취소 및 환불 신청
                </LSRgH1HeadLine>
              </MainBorderBtn>
            )}
          </div>

          <ul
            style={{
              marginTop: 20,
            }}
          >
            <li>
              <LSRgCaption03 style={{ color: "#6F7480" }}>
                * 결제 후 수강 이력이 없을 경우 취소 및 환불 신청이 가능합니다.
              </LSRgCaption03>
            </li>
            <li>
              <LSRgCaption03 style={{ color: "#6F7480" }}>
                * 그 외 문의 사항은 1:1 문의를 통해 진행 부탁드립니다.
              </LSRgCaption03>
            </li>
          </ul>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <LSRgH1HeadLine>결제 내역 상세</LSRgH1HeadLine>

            <LSBdBody02 style={{ marginTop: 16, color: "#5050FF" }}>
              구매 정보
            </LSBdBody02>

            <Divider
              style={{
                margin: "16px 0px",
              }}
            />

            <img
              src={
                paymentInfo?.thumbnailServerFileName
                  ? `${fileUrl}/${paymentInfo?.thumbnailServerFileName}`
                  : ""
              }
              style={{
                width: 335,
                height: 214,
                borderRadius: 10,
                marginBottom: 24,
              }}
              alt="video"
            />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <LSBdH1HeadLine>{paymentInfo?.lectureTitle}</LSBdH1HeadLine>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 40,
                }}
              >
                <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                  <LSBdCaption02 style={{ color: "#898e99" }}>
                    결제번호
                  </LSBdCaption02>
                  <LSRgCaption02>{paymentInfo?.pgPaymentId}</LSRgCaption02>
                </TopTextContain>
                <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                  <LSBdCaption02 style={{ color: "#898e99" }}>
                    결제일자
                  </LSBdCaption02>
                  <LSRgCaption02>
                    {moment(paymentInfo?.createdAt).format(
                      "YYYY.MM.DD HH:mm:ss",
                    )}
                  </LSRgCaption02>
                </TopTextContain>
                <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                  <LSBdCaption02 style={{ color: "#898e99" }}>
                    결제금액
                  </LSBdCaption02>
                  <LSRgCaption02>
                    {formatNumberWithCommas(paymentInfo?.realPay)}원
                  </LSRgCaption02>
                </TopTextContain>
                <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                  <LSBdCaption02 style={{ color: "#898e99" }}>
                    결제수단
                  </LSBdCaption02>
                  <LSRgCaption02>{paymentInfo?.payMethod}</LSRgCaption02>
                </TopTextContain>
                <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                  <LSBdCaption02 style={{ color: "#898e99" }}>
                    결제상태
                  </LSBdCaption02>
                  <LSRgCaption02>
                    {paymentInfo?.paymentStatus === "REFUND_COMPLETE"
                      ? "환불완료"
                      : paymentInfo?.paymentStatus === "REFUND_REQUEST"
                        ? "환불신청"
                        : "결제완료"}
                  </LSRgCaption02>
                </TopTextContain>
              </div>
            </div>

            <LSBdBody02 style={{ color: "#5050FF" }}>구매자 정보</LSBdBody02>

            <Divider
              style={{
                margin: "16px 0px",
              }}
            />

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                marginBottom: 40,
              }}
            >
              <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                <LSBdCaption02 style={{ color: "#898e99" }}>
                  구매자
                </LSBdCaption02>
                <LSRgCaption02>{paymentInfo?.name}</LSRgCaption02>
              </TopTextContain>
              <TopTextContain style={{ marginBottom: 6, gap: 10 }}>
                <LSBdCaption02 style={{ color: "#898e99" }}>
                  전화번호
                </LSBdCaption02>
                <LSRgCaption02>
                  {formatPhoneNumber(paymentInfo?.phoneNumber)}
                </LSRgCaption02>
              </TopTextContain>
              <TopTextContain style={{ gap: 10 }}>
                <LSBdCaption02 style={{ color: "#898e99" }}>
                  이메일
                </LSBdCaption02>
                <LSRgCaption02>{paymentInfo?.email}</LSRgCaption02>
              </TopTextContain>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <MainBtn
                onClick={() => {
                  navigate(route.my_page_classroom);
                }}
                style={{
                  width: "100%",
                }}
              >
                <LSRgH1HeadLine
                  style={{
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  나의 강의실 가기
                </LSRgH1HeadLine>
              </MainBtn>

              {canRequestRefund && (
                <MainBorderBtn
                  disabled={isRefunding}
                  onClick={() => {
                    setIsRefundModal(true);
                  }}
                  style={{
                    width: "100%",
                  }}
                >
                  <LSRgH1HeadLine
                    style={{
                      color: "#5050FF",
                      textAlign: "center",
                    }}
                  >
                    취소 및 환불 신청
                  </LSRgH1HeadLine>
                </MainBorderBtn>
              )}
            </div>

            <ul
              style={{
                marginTop: 20,
              }}
            >
              <li>
                <LSRgCaption01 style={{ color: "#6F7480" }}>
                  * 결제 후 수강 이력이 없을 경우 취소 및 환불 신청이
                  가능합니다.
                </LSRgCaption01>
              </li>
              <li>
                <LSRgCaption01 style={{ color: "#6F7480" }}>
                  * 그 외 문의 사항은 1:1 문의를 통해 진행 부탁드립니다.
                </LSRgCaption01>
              </li>
            </ul>
          </ContentContainer>
        </MOContainer>
      )}

      {isRefundModal ? (
        <ConfirmModal
          isScroll={false}
          title={"취소 및 환불 신청하시겠습니까?"}
          yText={isRefunding ? "신청 중..." : "확인"}
          onClick={() => {
            setIsRefundModal(false);
          }}
          onYClick={() => {
            setIsRefundModal(false);
            refundFunc();
          }}
        />
      ) : null}
    </LecturePaymentCompleteSection>
  );
};

export default MyPagePaymentDetail;

const LecturePaymentCompleteSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) => (props.$isSmall ? "40px 0px 80px 0px" : "0px")};
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const TopTextContain = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
`;

const TopRightText = styled(LSBdBody01)`
  width: 55px;
  margin-right: 18px;
  color: #898e99;
`;

const TopLeftText = styled(LSRgBody01)`
  color: #000000;
`;

const Divider = styled.div.attrs((props) => {})`
  width: 100%;
  height: 1px;
  background: #dbdde0;
`;
